import { FC } from 'react';
import { ListCheckNote, ListCheckNoteLabel } from '../../styles';

const NoteBlock: FC<{ text: string | null }> = ({ text }) =>
  text ? (
    <ListCheckNote data-testid="list-check-note">
      <ListCheckNoteLabel>Note</ListCheckNoteLabel>
      {text}
    </ListCheckNote>
  ) : null;

export default NoteBlock;
